module.exports = __webpack_public_path__ + "static/media/unboared_beta_light.7d00e2f2.png";